import { getOpcoProjects } from "../api/opcoProjectsHttpClient";

export const useOpcoProjectsGrid = () => {
  return { fetchGridData: getOpcoProjects };
};
